var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8e1ef;}.cls-2{fill:#0e6ae0;}.cls-3{fill:#0593ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Shield Lock",
    id: "Shield_Lock-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,6C19.51,6,16.84,2.46,16.82,2.43A1,1,0,0,0,16,2a.94.94,0,0,0-.83.42S12.49,6,4,6A1,1,0,0,0,3,7v8.76c0,9.25,7.11,12,11.35,13.66l1.27.5a.94.94,0,0,0,.76,0l1.26-.5C21.89,27.77,29,25,29,15.76V7A1,1,0,0,0,28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,15H14a1,1,0,0,1-1-1V12a3,3,0,0,1,6,0v2A1,1,0,0,1,18,15Zm-3-2h2V12a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 10,
    rx: 3,
    ry: 3,
    width: 10,
    x: 11,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,20a2,2,0,1,1,2-2A2,2,0,0,1,16,20Zm0-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.41ad79f8.svg";
export { ForwardRef as ReactComponent };